import { createActions } from 'redux-actions';

import types from 'state/direct-order/repeated-from/actionTypes';

const { directOrder } = createActions({
  [types.SET_REPEATED_FROM]: ({ orderId }) => ({ orderId }),
});

export default directOrder;
